import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";

// "Leistungen"-Dropdown in der Hauptnavigation — direkte Links zu den Säulen-Seiten.
// Modelliert nach LanguageSelector (useState + Click-Outside + ChevronDown).
const LeistungenMenu = ({ onNavigate }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const items = [
    { label: t("services.services.kiVertrieb.title"), route: "/ki-vertrieb" },
    {
      label: t("services.services.kiVersicherung.title"),
      route: "/ki-versicherung",
    },
    {
      label: t("services.services.dashboards.title"),
      route: "/management-dashboards",
    },
    { label: t("navigation.buecher"), route: "/buecher" },
  ];

  const go = (route) => {
    navigate(route);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setIsOpen(false);
    if (onNavigate) onNavigate();
  };

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div
      className="relative"
      ref={ref}
      role="combobox"
      aria-expanded={isOpen}
      aria-haspopup="listbox"
      aria-label={t("navigation.leistungen")}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen(!isOpen);
          } else if (e.key === "Escape" && isOpen) {
            setIsOpen(false);
          }
        }}
        className="flex items-center gap-1 text-white cursor-pointer hover:text-[#C5A66A] hover:scale-105 transition-colors duration-300 font-medium text-sm lg:text-base"
      >
        {t("navigation.leistungen")}
        <ChevronDown
          size={16}
          className={`transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          aria-hidden="true"
        />
      </button>

      {isOpen && (
        <ul
          className="absolute left-0 mt-2 w-64 bg-[#1a2b42] border border-gray-600 rounded-lg shadow-lg z-50 py-1"
          role="listbox"
          aria-label={t("navigation.leistungen")}
        >
          {items.map((item) => (
            <li key={item.route} role="option" aria-selected="false">
              <button
                onClick={() => go(item.route)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    go(item.route);
                  }
                }}
                className="w-full text-left px-4 py-3 text-white hover:bg-[#0F1B2D] hover:text-[#C5A66A] transition-colors duration-200 text-sm"
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LeistungenMenu;
